<script>
export default {
  name: 'TituloSecao'
}
</script>

<template>
  <div class="bg-light lter b-b wrapper-md">
    <div class="row">
      <div class="col-sm-6 col-xs-12">
        <h1 class="font-thin h3">
          <slot></slot>
        </h1>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// TituloSecao.vue?2077d80c